import { Component, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { NgOtpInputConfig } from 'ng-otp-input';

@Component({
    selector: 'black-otp',
    templateUrl: './otp.component.html',
    styleUrls: ['./otp.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OtpComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class OtpComponent implements ControlValueAccessor {
  otpConfig: NgOtpInputConfig = {
    length: 6,
    inputStyles: {
      display: 'inline',
    },
    allowNumbersOnly: true,
  };

  otpFormControl: FormControl = new FormControl('');

  writeValue(obj: any): void {
    this.otpFormControl.setValue(obj);
  }
  registerOnChange(fn: any): void {
    this.otpFormControl.valueChanges.subscribe((val) => fn(val));
  }
  registerOnTouched(fn: any): void {
    this.otpFormControl.valueChanges.subscribe((val) => fn(val));
  }
}
